<template>
  <div class="rightBox" :class="operation?'rightActive':''">
    <!-- 操作按钮 -->
    <div class="right">
      <ul>
        <li class="operationClose" @click="operationClose" v-if="operation">
          <i class="el-icon-s-unfold"></i>
          <div class="rightName" style="display: block;">收起</div>
        </li>
        <li
          v-for="(item, index) in rightList"
          :key="index"
          class="rightList"
          :class="item.active?'rightListActive':''"
          @click="operationChange(item)"
        >
          <svg-icon :iconClass="item.icon"></svg-icon>
          <div class="rightName">{{item.name}}</div>
        </li>
      </ul>
      <div class="rightBottom">
        <div class="top" @click="top">
          <svg-icon iconClass="top"></svg-icon>
        </div>
        <el-popover placement="left-start" trigger="hover">
          <div style="text-align: center;">
            <img class="kefu" src="@/assets/kefu.jpg" alt />
          </div>
          <div class="rightBottomBtn" slot="reference">客服</div>
        </el-popover>
        <div class="rightBottomBtn" @click="feedbackClose">反馈</div>
        <el-popover placement="left-start" trigger="hover">
          <div style="text-align: center;">
            <img class="kefu" src="@/assets/douyin.jpg" alt />
          </div>
          <div class="rightBottomBtn" slot="reference">抖音</div>
        </el-popover>
      </div>
    </div>

    <!-- 感兴趣操作 -->
    <div v-if="port === 'teacher'">
      <div class="operation" v-show="operation" v-if="showList === 0">
        <div class="operationTitle">{{listName}}的职位</div>
        <div v-if="list.length > 0" class="listHeight">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="list"
            @click="goSchoolDetail(item)"
          >
            <div class="listBox listBoxs">
              <div class="school_avatar">
                <el-avatar :size="62" :src="item.school_avatar"></el-avatar>
              </div>
              <div class="schoolContent">
                <div class="textOverflow">{{item.school_name}}</div>
                <div class="textOverflow">{{item.address}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <noData pad="30%"></noData>
        </div>
      </div>
      <div class="operation" v-show="operation" v-if="showList === 1">
        <div class="operationTitle">{{listName}}的职位</div>
        <div v-if="list.length > 0" class="listHeight">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="list"
            @click="goSchoolDetail(item)"
          >
            <div class="listBox listBoxs">
              <div class="school_avatar">
                <el-avatar :size="62" :src="item.avatar"></el-avatar>
              </div>
              <div class="schoolContent">
                <div class="textOverflow">{{item.school_name}}</div>
                <div
                  class="textOverflow"
                  :class="item.other_party_is_read === 1?'':'noRead'"
                >{{item.other_party_is_read === 1?'对方已读':'对方未读'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <noData pad="30%"></noData>
        </div>
      </div>
      <div class="operation" v-show="operation" v-if="showList === 2">
        <div class="operationTitle">{{listName}}的职位</div>
        <div v-if="list.length > 0" class="listHeight">
          <div v-for="(item, index) in list" :key="index" class="list" @click="goDetail(item)">
            <div class="listBox">
              <div class="clearfix">
                <div class="fl job_name">{{item.job_name}}</div>
                <div
                  class="fr money"
                >{{item.salary_package}}{{item.salary_package === '面议'?'':'元/月'}}</div>
              </div>
              <div
                class="listContent"
              >{{item.person_number?'招聘人数：':''}}{{item.person_number}}&nbsp;|&nbsp;{{item.work_experience?'工作经验：':''}}{{item.work_experience}}</div>
              <div class="person">
                <el-avatar size="small" :src="item.avatar"></el-avatar>
                <span>{{item.school_name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <noData pad="30%"></noData>
        </div>
      </div>
    </div>

    <!-- 园长操作 -->
    <div v-if="port === 'boss'">
      <div class="operation" v-show="operation" v-if="showList === 3">
        <div class="operationTitle">{{listName}}的职位</div>
        <div v-if="list.length > 0" class="listHeight">
          <div v-for="(item, index) in list" :key="index" class="list" @click="goTeaDetail(item)">
            <div class="listBox listBoxs">
              <div class="school_avatar">
                <el-avatar :size="62" :src="item.avatar"></el-avatar>
              </div>
              <div class="schoolContent">
                <div class="textOverflow">{{item.vita_name}}</div>
                <div class="textOverflow">{{item.desired_position}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <noData pad="30%"></noData>
        </div>
      </div>
      <div class="operation" v-show="operation" v-if="showList === 4">
        <div class="operationTitle">{{listName}}的职位</div>
        <div v-if="list.length > 0" class="listHeight">
          <div v-for="(item, index) in list" :key="index" class="list" @click="goTeaDetail(item)">
            <div class="listBox listBoxs">
              <div class="school_avatar">
                <el-avatar :size="62" :src="item.avatar"></el-avatar>
              </div>
              <div class="schoolContent">
                <div class="textOverflow">{{item.vita_name}}</div>
                <div
                  class="textOverflow"
                  :class="item.other_party_is_read === 1?'':'noRead'"
                >{{item.other_party_is_read === 1?'对方已读':'对方未读'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <noData pad="30%"></noData>
        </div>
      </div>
    </div>

    <!-- 反馈 -->
    <el-dialog
      title="反馈"
      :visible.sync="feedbackDialog"
      width="50%"
      append-to-body
      :before-close="feedbackClose"
    >
      <el-form ref="feedbackForm" :model="feedbackForm" :rules="rules" class="feedbackWid">
        <el-form-item prop="channel_source" label="您是从什么渠道知道幼聘网的：">
          <div>
            <el-radio-group v-model="feedbackForm.channel_source">
              <el-radio
                :label="item.id"
                v-for="(item, index) in channel_sourceList"
                :key="index"
                style="margin-top: 10px;"
              >{{item.name}}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item
          prop="is_find_work_teacher"
          :label="port === 'teacher'?'您是否通过幼聘网找到了工作：':'您是否通过幼聘网招到了老师：'"
        >
          <div style="width: 100%;">
            <el-radio-group v-model="feedbackForm.is_find_work_teacher">
              <el-radio-button
                :label="item.id"
                v-for="(item, index) in yesNo"
                :key="index"
              >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="您认为幼聘网哪些方面需要改进的：">
          <div>
            <el-checkbox-group v-model="feedbackForm.improve_type">
              <el-checkbox
                v-for="(item, index) in improvementList"
                :label="item.id"
                :key="index"
              >{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="反馈意见：">
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 5}"
              placeholder="您的宝贵意见对我们非常重要，请在此输入"
              v-model="feedbackForm.content"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="联系方式：">
          <div>
            <el-input placeholder="如有必要，留下手机号码，方便我们咨询跟进" v-model="feedbackForm.contact"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feedbackClose">取消</el-button>
        <el-button type="primary" @click="feedbackSuccess">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import noData from "@/components/noData";
import kefu from "@/assets/kefu.jpg";
export default {
  components: {
    noData
  },
  watch: {
    $route() {
      this.port = sessionStorage.getItem("port");
      if (this.port === "teacher") {
        this.rightList = [
          {
            id: 0,
            name: "感兴趣",
            icon: "xin",
            active: false
          },
          {
            id: 1,
            name: "沟通过",
            icon: "communicate",
            active: false
          },
          {
            id: 2,
            name: "已投递",
            icon: "Delivery",
            active: false
          }
        ];
      } else {
        this.rightList = [
          {
            id: 3,
            name: "感兴趣",
            icon: "xin",
            active: false
          },
          {
            id: 4,
            name: "沟通过",
            icon: "communicate",
            active: false
          }
        ];
      }
    }
  },
  data() {
    return {
      showList: "",
      rightList: [],
      operation: false,

      // 列表
      list: [],
      company_typelist: ["幼儿园", "早教/托育机构", "综合教育公司", "其他"],
      listName: "",
      port: "",
      feedbackDialog: false,
      feedbackForm: {
        improve_type: []
      },

      // 渠道来源
      channel_sourceList: [
        {
          id: "1",
          name: "微信群",
          active: false
        },
        {
          id: "2",
          name: "微信公众号",
          active: false
        },
        {
          id: "3",
          name: "微信视频号",
          active: false
        },
        {
          id: "4",
          name: "朋友圈",
          active: false
        },
        {
          id: "5",
          name: "抖音",
          active: false
        },
        {
          id: "6",
          name: "接到电话",
          active: false
        },
        {
          id: "7",
          name: "收到短信",
          active: false
        },
        {
          id: "8",
          name: "网站搜索",
          active: false
        },
        {
          id: "9",
          name: "招聘会",
          active: false
        },
        {
          id: "10",
          name: "朋友推荐",
          active: false
        },
        {
          id: "11",
          name: "其他渠道",
          active: false
        }
      ],

      // 是否找到
      yesNo: [
        {
          id: "1",
          name: "是",
          active: false
        },
        {
          id: "0",
          name: "否",
          active: false
        }
      ],

      // 改进
      improvementList: [
        {
          id: "1",
          name: "账号登录",
          active: false
        },
        {
          id: "2",
          name: "创建简历",
          active: false
        },
        {
          id: "3",
          name: "创建园所",
          active: false
        },
        {
          id: "4",
          name: "发布职位",
          active: false
        },
        {
          id: "5",
          name: "搜索职位",
          active: false
        },
        {
          id: "6",
          name: "搜索简历",
          active: false
        },
        {
          id: "7",
          name: "回复消息",
          active: false
        },
        {
          id: "8",
          name: "动态通知",
          active: false
        },
        {
          id: "9",
          name: "隐私设置",
          active: false
        },
        {
          id: "10",
          name: "评价管理",
          active: false
        },
        {
          id: "11",
          name: "地图找工作",
          active: false
        },
        {
          id: "12",
          name: "客服咨询",
          active: false
        },
        {
          id: "13",
          name: "招聘会",
          active: false
        },
        {
          id: "14",
          name: "会员服务",
          active: false
        },
        {
          id: "15",
          name: "信息质量",
          active: false
        },
        {
          id: "16",
          name: "其他问题",
          active: false
        }
      ],

      rules: {
        channel_source: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        is_find_work_teacher: [
          { required: true, message: "请选择是否" + this.port === 'teacher'?'通过幼聘网找到工作':'通过幼聘网招到了老师', trigger: "change" }
        ]
      }
    };
  },
  mounted() {
    this.port = sessionStorage.getItem("port");
    if (this.port === "teacher") {
      this.rightList = [
        {
          id: 0,
          name: "感兴趣",
          icon: "xin",
          active: false
        },
        {
          id: 1,
          name: "沟通过",
          icon: "communicate",
          active: false
        },
        {
          id: 2,
          name: "已投递",
          icon: "Delivery",
          active: false
        }
      ];
    } else {
      this.rightList = [
        {
          id: 3,
          name: "感兴趣",
          icon: "xin",
          active: false
        },
        {
          id: 4,
          name: "沟通过",
          icon: "communicate",
          active: false
        }
      ];
    }
  },
  methods: {
    //   关闭反馈
    feedbackClose() {
      if(this.Cookies.get('UserToken')) {
        this.feedbackDialog = !this.feedbackDialog;
        this.feedbackForm = {
          improve_type: []
        }
      } else {
        this.$message({
          message: '请先登录',
          type: 'success'
        });
        this.$router.push({ path: '/login' })
      }
    },

    // 提交反馈
    feedbackSuccess() {
        this.$refs.feedbackForm.validate((valid) => {
          if (valid) {
            this.feedbackForm.user_client = this.port === 'teacher'?'teacher':'school'
            this.feedbackForm.improve_type = JSON.stringify(this.feedbackForm.improve_type)
            this.api.post("/624ffda56147c", this.feedbackForm).then(r => {
                this.feedbackClose()
                this.$message({
                    message: '提交成功，感谢您的反馈',
                    type: 'success'
                });
            });
          } else {
            return false;
          }
        });
    },

    //   返回顶部
    top() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },

    // 操作
    operationChange(o) {
      this.operation = true;
      this.rightList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.listName = o.name;
      this.showList = o.id;

      // 测试
      switch (o.id) {
        case 0:
          this.api.get("/5cff6f7b7069d", { page: 1, size: 200 }).then(r => {
            this.list = r.data.list;
          });
          break;

        case 1:
          this.api.post("/60a87105b04fb", { page: 1, size: 200 }).then(r => {
            this.list = r.data.list;
          });
          break;
        case 2:
          this.api.get("/5cff60462d0cb", { page: 1, size: 200 }).then(r => {
            this.list = r.data.list;
          });
          break;
        case 3:
          this.api.get("/5cff7a99d379d", { page: 1, size: 200 }).then(r => {
            this.list = r.data.list;
          });
          break;
        case 4:
          this.api.post("/60a8712610dd3", { page: 1, size: 200 }).then(r => {
            this.list = r.data.list;
          });
          break;
      }
    },

    // 关闭操作
    operationClose() {
      this.operation = false;
      this.rightList.forEach(o => {
        o.active = false;
      });
    },

    // 去职位详情
    goDetail(o) {
      if (this.$route.path === "/job/postDetail") {
        this.$router.push({
          query: {
            jid: o.jid
          }
        });
      } else {
        this.$router.push({
          path: "/job/postDetail",
          query: {
            jid: o.jid
          }
        });
      }
    },

    // 去简历详情
    goTeaDetail(o) {
      if (this.$route.path === "/boss/resumeDetail") {
        this.$router.push({
          query: {
            vid: o.vid
          }
        });
      } else {
        this.$router.push({
          path: "/boss/resumeDetail",
          query: {
            vid: o.vid
          }
        });
      }
    },

    // 去园所详情
    goSchoolDetail(o) {
      if (this.$route.path === "/job/schoolDetail") {
        this.$router.push({
          query: {
            sid: o.sid
          }
        });
      } else {
        this.$router.push({
          path: "/job/schoolDetail",
          query: {
            sid: o.sid
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rightBox {
  position: fixed;
  right: 0;
  top: 0;
  box-shadow: -1px 0 8px rgba(0, 0, 0, 0.03);
  background: white;
  height: 100%;
  z-index: 99;
}
.right {
  width: 40px;
  height: 100%;
  transition: width 0.5s;
  text-align: center;
  padding-top: 15px;
  svg {
    transition: all 0.2s;
    color: #999;
  }
  .rightName {
    display: none;
    transition: all 0.2s;
    font-size: 12px;
    padding-top: 5px;
  }
  .rightListActive {
    color: #ff5b12;
    svg {
      color: #ff5b12;
    }
  }
}
.right:hover {
  width: 61px;
  .rightName {
    display: block;
  }
  .rightBottom {
    width: 61px;
  }
}
.rightList {
  cursor: pointer;
  padding-bottom: 20px;
  height: 46px;
}
.rightList:hover {
  color: #ff5b12;
  svg {
    color: #ff5b12;
  }
}
.rightBottom {
  position: fixed;
  bottom: 0;
  width: 40px;
  text-align: center;
  transition: all 0.5s;
  .rightBottomBtn {
    height: 46px;
    color: #999;
  }
  .top {
    padding-bottom: 20px;
  }
  > div {
    cursor: pointer;
    transition: all 0.2s;
  }
  > div:hover {
    color: #ff5b12;
  }
}
.operation {
  position: fixed;
  width: 311px;
  height: 100%;
  right: 0;
  top: 0;
  transition: all 0.5s;
  background: white;
  .operationTitle {
    padding: 30px 22px 20px 20px;
    background: #fbfbfd;
    color: #414a60;
  }
  .list:hover {
    background: #f8f9fb;
  }
  .list {
    cursor: pointer;
    .listBoxs {
      > div {
        display: inline-block;
        vertical-align: middle;
      }
      .school_avatar {
        width: 62px;
      }
      .schoolContent {
        width: 70%;
        margin-left: 4%;
        .noRead {
          color: red !important;
        }
        > div:nth-child(2) {
          font-size: 14px;
          padding-top: 5px;
          color: #9fa3af;
        }
      }
    }
    .listBox {
      padding: 20px 0 11px 0;
      border-bottom: 1px dotted #e3e7ed;
      margin: 0 20px;
      .job_name {
        color: #61687c;
        font-weight: bold;
        font-size: 14px;
      }
      .money {
        color: #fd7240;
        font-weight: bold;
        font-size: 14px;
      }
      .listContent {
        font-size: 12px;
        color: #9fa3af;
        padding: 10px 0 15px 0;
      }
      .person {
        font-size: 12px;
        color: #9fa3af;
        span:nth-child(2) {
          margin-left: 10px;
        }
        span {
          vertical-align: middle;
        }
      }
    }
  }
}
.rightActive {
  right: 311px;
}
.operationClose {
  color: #999;
  padding-bottom: 20px;
}
.rightHeight {
  top: 0;
}
.kefu {
  width: 150px;
  height: 150px;
}
.listHeight {
  height: calc(100vh - 71px);
  overflow: auto;
}
.listHeight::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 7px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.listHeight::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: #999;
}

.listHeight::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.wid {
  width: 100%;
}
</style>

<style lang="scss">
    .feedbackWid {
        .el-form-item__label {
            width: 100%;
            text-align: left;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/right/index.vue